// Ajuste os caminhos ainda não confirmados para os endpoints reais do backend.
export const API_PATHS = {
  login: '/auth/login',
  trocarSenha: '/auth/primeiro-acesso',
  pedidos: '/admin/checkout/pedidos',
  parceiros: '/admin/parceiros',
  usuarios: '/parceiro/usuarios',
  lembretes: '/parceiro/lembretes'
};
